import React from "react";
import type { ParseKeys } from "i18next";
import { FeatureFlagName, FeatureFlags } from "../../../../tenant/features/featureFlags";
import {
	BuyElectricityQuickServiceIcon,
	EnergyManagementQuickServiceIcon,
	ServiceRequestQuickServiceIcon,
	ElectricityBillsQuickServiceIcon,
	EnergyProfileEditIcon,
	SavedBeneficiariesIcon,
	BillsPaymentIcon,
	AccountActivitiesIcon,
	TransferUnitQuickServiceIcon,
	// Hidden quick-service icons (WEB-IMP1) — kept for future restore.
	// BorrowUnitsQuickServiceIcon,
	// NewServiceQuickServiceIcon,
	// GetSolarIcon,
	// AnalyticsIcon,
	// DisputeBillIcon,
	// SolarConsumptionIcon,
	// ReportIssuesIcon,
} from "../../../../assets/icons";

export interface QuickServiceItem {
	id: string;
	title: ParseKeys;
	icon: React.ReactNode;
	link?: string;
	isLocked?: boolean;
	isShow?: (flags: FeatureFlags) => boolean;
	onClick?: () => void;
}

export const primaryServiceItems: QuickServiceItem[] = [
	{
		id: "buy-electricity",
		title: "common.labels.buyElectricity",
		icon: <BuyElectricityQuickServiceIcon />,
		link: "/buy-electricity",
		isShow: featureFlags => featureFlags[FeatureFlagName.BUY_ELECTRICITY],
	},
	{
		id: "energy-management",
		title: "common.labels.energyManagement",
		icon: <EnergyManagementQuickServiceIcon />,
		link: "/energy-management",
		// isShow: false, // controlled by consumer type
		// isLocked: true,
	},
	{
		id: "service-request",
		title: "common.labels.serviceRequest",
		icon: <ServiceRequestQuickServiceIcon />,
		link: "/service-request",
		isShow: featureFlags => featureFlags[FeatureFlagName.SERVICE_REQUEST],
	},
	{
		id: "electricity-bills",
		title: "home.web.electricityBills",
		icon: <ElectricityBillsQuickServiceIcon />,
		link: "/history",
	},
	{
		id: "transfer-unit",
		title: "Transfer Units" as ParseKeys,
		icon: <TransferUnitQuickServiceIcon />,
		link: "/transfer-unit",
		isShow: featureFlags => featureFlags[FeatureFlagName.TRANSFER_UNIT],
	},
	// Hidden from the primary grid
	// {
	// 	id: "borrow-units",
	// 	title: "Borrow Units",
	// 	icon: <BorrowUnitsQuickServiceIcon />,
	// 	link: "/buy-electricity?action=borrow",
	// },
	// {
	// 	id: "new-service",
	// 	title: "New Service",
	// 	icon: <NewServiceQuickServiceIcon />,
	// 	isLocked: true,
	// },
];

export const moreServiceItems: QuickServiceItem[] = [
	{
		id: "energy-profile",
		title: "common.labels.energyProfile",
		icon: <EnergyProfileEditIcon />,
		link: "/settings/energy-profile",
	},
	{
		id: "saved-beneficiaries",
		title: "common.labels.savedBeneficiaries",
		icon: <SavedBeneficiariesIcon />,
		link: "/saved-beneficiaries",
		isShow: featureFlags => featureFlags[FeatureFlagName.SAVED_BENEFICIARIES],
	},
	{
		id: "account-activities",
		title: "home.web.accountActivities",
		icon: <AccountActivitiesIcon />,
		link: "/account-activities",
		isShow: featureFlags => featureFlags[FeatureFlagName.STATEMENT_OF_ACCOUNT],
	},
];

// Keep for any legacy usage
export const quickServiceItems: QuickServiceItem[] = [...primaryServiceItems, ...moreServiceItems];
